import * as React from 'react'
import { Link } from 'react-router-dom'
import UIMessages from '../../../utils/ui-messages'
import history from 'src/history'
import { Button } from '@mobiscroll/react-latest'

interface IProps {
  isSaved: boolean
  isSaving: boolean
  finishPath?: string
  nextStepPath?: string
  previousStepPath?: string
  skipStepPath?: string
  saveDisabled?: boolean
  onSave?: () => void
}

const CreateRiderBottomBar = ({
  isSaved,
  isSaving,
  finishPath,
  nextStepPath,
  previousStepPath,
  skipStepPath,
  onSave,
  saveDisabled = false
}: IProps) => {
  const handleRedirect = (path: string) => {
    history.push(path)
  }
  return (
    <div className='flex absolute bottom-0 flex items-center bg-light-grey7 px2 py1 w100'>
      <div className='flex justify-end w100 pr3'>
        {previousStepPath && (
          <Button
            aria-label={`Go to previous step: ${previousStepPath}`}
            className='mbsc-outline-success-btn'
            onClick={() => handleRedirect(previousStepPath)}
          >
            {UIMessages.common.previousStep}
          </Button>
        )}
        {!finishPath && skipStepPath && (
          <Button
            aria-label={`Go to next step: ${skipStepPath}`}
            className='mbsc-flat-white-btn'
            onClick={() => handleRedirect(skipStepPath)}
          >
            {UIMessages.common.skip}
          </Button>
        )}
        {!isSaved && onSave && (
          <Button className='mbsc-success-btn' onClick={onSave}>
            {isSaving ? UIMessages.common.saving : UIMessages.common.save}
          </Button>
        )}
        {!isSaved && !onSave && !saveDisabled && (
          <Button className='mbsc-success-btn' type='submit'>
            {isSaving ? UIMessages.common.saving : UIMessages.common.save}
          </Button>
        )}
        {!finishPath && isSaved && nextStepPath && (
          <Button
            aria-label={`Continue to next step: ${nextStepPath}`}
            className='mbsc-success-btn'
            onClick={() => handleRedirect(nextStepPath)}
          >
            {UIMessages.common.continueLabel}
          </Button>
        )}
        {finishPath && isSaved && (
          <Button
            aria-label={`Continue to final step: ${finishPath}`}
            className='mbsc-success-btn'
            onClick={() => handleRedirect(finishPath)}
          >
            {UIMessages.common.finish}
          </Button>
        )}
      </div>
    </div>
  )
}

export default CreateRiderBottomBar



// WEBPACK FOOTER //
// ./src/components/riders/createrider/CreateRiderBottomBar.tsx